import * as React from 'react';
import * as _ from 'lodash';
import {
  ISearchListProps,
  ISearchListState,
  ResultItem,
  SearchModel,
  CategoryType,
  SortType,
  SearchResultModel,
} from './SearchList.types';
import { ToggleBox } from 'sos-common/js/components/ToggleBox/ToggleBox';
import { ContentPagination } from 'sos-common/js/components/ContentPagination/ContentPagination';
import LoadingSpinner from 'sos-common/js/components/LoadingSpinner/LoadingSpinner';

const sessionModelName = 'sos_search_state';

export class SearchList extends React.Component<ISearchListProps, ISearchListState> {
  private _queue: NodeJS.Timeout[] = [];
  private _isPageChange: boolean;
  constructor(props: ISearchListProps) {
    super(props);

    this.state = {
      currentSearchState: this.createInitialSearchState(),
      relevansbuttonIsActive: true,
      sortbuttonIsActive: false,
      amneopen: false,
      productopen: false,
      filteropen: false,
      isSearching: false,
      searchResultModel: _.cloneDeep(this.props.initalSearchResultModel),
      isDataLoading: false,
      isError: false,
    };
    this._isPageChange = false;
  }

  /**
   * Construct the initial SearchModel object. Some values are predefined whereas some are dependent on the props.
   * This is the model which is being sent to the backend on change of search parameters (query, categoeies, filters etc.).
   * Make sure to **cloneDeep** this object with lodash when updating the state because it has nested objects.
   */
  createInitialSearchState = (): SearchModel => {
    let model: SearchModel = {
      PageNo: 1,
      Query: this.props.initalSearchResultModel.Query,
      MandatoryCategories: [],
      StandardCategories: [],
      SearchCategories: [],
      IsDocument: false,
      PageSize: this.props.pageSize,
      CurrentPageId: this.props.currentPageId,
      SortBy: SortType.Relevance,
    };

    return model;
  };

  componentDidMount() {
    //searchResultModel
    if (typeof window !== 'undefined' && sessionStorage.getItem(sessionModelName) != undefined) {
      const sessionState: ISearchListState = JSON.parse(sessionStorage.getItem(sessionModelName));
      if (this.state.currentSearchState.Query === sessionState.currentSearchState.Query) {
        this.setState(sessionState);
      } else {
        sessionStorage.removeItem(sessionModelName);
      }
    }
  }
  componentDidUpdate(prevProps: ISearchListProps, prevState: ISearchListState) {
    if (_.isEqual(prevState.currentSearchState, this.state.currentSearchState)) return;

    //do not delay if it's a page change
    if (this._isPageChange) {
      this._isPageChange = false;
      this.sendQueryToServer()
        .then((response) => {
          this.setState({
            searchResultModel: response,
            isDataLoading: false,
            isError: false,
          });
          sessionStorage.clear();
          //sessionStorage.setItem('searchResultModel', JSON.stringify(response))
          sessionStorage.setItem(sessionModelName, JSON.stringify(this.state));
        })
        .catch((response) => {
          this.handleError();
        });
    } else {
      this.delay(500).then((_) => {
        this.sendQueryToServer()
          .then((response) => {
            this.setState({
              searchResultModel: response,
              isDataLoading: false,
              isError: false,
            });
            sessionStorage.clear();
            //sessionStorage.setItem('searchResultModel', JSON.stringify(response))
            sessionStorage.setItem(sessionModelName, JSON.stringify(this.state));
          })
          .catch((response) => {
            this.handleError();
          });
      });
    }
  }

  handleError = () => {
    this.setState({
      isError: true,
    });
  };

  sendQueryToServer = (): Promise<SearchResultModel> => {
    this.setState({ isDataLoading: true });

    const url = '/_api/search';
    return fetch(url, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(this.state.currentSearchState),
      credentials: 'same-origin',
      method: 'POST',
    })
      .then((response) => {
        return response.json();
      })
      .catch((response) => {
        return response.json();
      });
  };

  delay = (interval: number) => {
    return new Promise((resolve) => {
      let item = setTimeout(resolve, interval);
      this._queue.push(item);
      while (this._queue.length > 1) {
        let toClear = this._queue.shift();
        clearTimeout(toClear);
      }
    });
  };

  arrayRemove = (arr, value) => {
    return arr.filter(function (ele) {
      return ele != value;
    });
  };

  addToOrRemoveFromArray = (arr, val) => {
    const index = arr.indexOf(val);

    if (index === -1) {
      //elem not found, add
      arr.push(val);
    } else {
      arr = this.arrayRemove(arr, val);
    }
    return arr;
  };

  checkItem = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { currentSearchState } = this.state;
    const { categoryFilter, searchCategories, useFacets } = this.props;
    var searchStateClone = _.cloneDeep(currentSearchState);

    //set MandatoryCategories and StandardCategories according to the incoming values
    const value = e.currentTarget.value;
    //const checked = e.currentTarget.checked;

    const selectedCategoryItem = categoryFilter.find((x) => x.Id.toString() === value);
    if (selectedCategoryItem && selectedCategoryItem.Category === CategoryType.Mandatory) {
      searchStateClone.MandatoryCategories = this.addToOrRemoveFromArray(
        searchStateClone.MandatoryCategories,
        selectedCategoryItem.Id
      );
    } else {
      if (useFacets) {
        const selectedTerm = searchCategories.find((x) => x.Term === value);
        if (selectedTerm) {
          searchStateClone.SearchCategories = this.addToOrRemoveFromArray(
            searchStateClone.SearchCategories,
            selectedTerm.Term
          );
        }
      } else {
        searchStateClone.StandardCategories = this.addToOrRemoveFromArray(
          searchStateClone.StandardCategories,
          selectedCategoryItem.Id
        );
      }
    }

    searchStateClone.PageNo = 1;
    this.setState({
      currentSearchState: searchStateClone,
    });
  };

  render(): JSX.Element {
    //Update the number of filterd result
    const { isDataLoading, isError } = this.state;
    let activeRelevanceClass = 'search-result__link-active';
    let activeSortClass = '';
    if (this.state.relevansbuttonIsActive) {
      activeRelevanceClass = 'search-result__link-active';
    }
    if (this.state.sortbuttonIsActive) {
      activeRelevanceClass = '';
      activeSortClass = 'search-result__link-active';
    }

    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">{this.renderCheckbox()}</div>
          </div>
        </div>
        {isError && (
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="search-result__no-results">Vänligen försök igen senare.</div>
              </div>
            </div>
          </div>
        )}
        {!isError && (
          <div className="search-result__results-wrapper" role="alert">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <h2>{this.props.searchresultHeading}</h2>
                  {this.renderDidYouMean()}
                </div>
                <div className="col-lg-12">
                  <div className="search-result__info">
                    <div className="search-result__info-heading">
                      Visar {this.state.searchResultModel.ResultItems.length.toString()} av{' '}
                      {this.state.searchResultModel.TotalHits.toString()} resultat
                    </div>
                    <div className="search-result__sort-container">
                      <button
                        type="button"
                        className={`stripped-button search-result__sort search-result__sort-date ${activeRelevanceClass}`}
                        onClick={this.sortRelevans}>
                        Relevans
                      </button>
                      <button
                        type="button"
                        className={`stripped-button search-result__sort search-result__sort-date ${activeSortClass}`}
                        onClick={this.sortDate}>
                        Datum
                      </button>
                    </div>
                  </div>
                </div>

                {isDataLoading && <LoadingSpinner darkColor={true} />}
                <div className="col-lg-12">
                  <div className="search-result__result" role="log" aria-atomic="false">
                    <ContentPagination
                      data={this.state.searchResultModel.ResultItems.map(this.renderItem)}
                      pageSize={this.props.pageSize}
                      pageCount={Math.ceil(this.state.searchResultModel.TotalHits / this.props.pageSize)}
                      onChangePageCb={this.setNewPage}
                      noResultText={`Din filterering gav tyvärr inga träffar.`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  setNewPage = (newPage: number) => {
    const { currentSearchState } = this.state;
    let searchStateClone = _.cloneDeep(currentSearchState);
    searchStateClone.PageNo = newPage;

    this._isPageChange = true;

    document.body.scrollTop = 50; // For Safari
    document.documentElement.scrollTop = 50;

    this.setState({
      currentSearchState: searchStateClone,
    });
  };

  sortDate = () => {
    const { currentSearchState } = this.state;
    let searchStateClone = _.cloneDeep(currentSearchState);
    searchStateClone.SortBy = SortType.Date;

    this.setState({
      currentSearchState: searchStateClone,
      sortbuttonIsActive: true,
      relevansbuttonIsActive: false,
    });
  };

  sortRelevans = () => {
    const { currentSearchState } = this.state;
    let searchStateClone = _.cloneDeep(currentSearchState);
    searchStateClone.SortBy = SortType.Relevance;

    this.setState({
      currentSearchState: searchStateClone,
      relevansbuttonIsActive: true,
      sortbuttonIsActive: false,
    });
  };

  private renderDidYouMean = () => {
    const didYouMean = this.state.searchResultModel.DidYouMean || [];

    return (
      <div className="search-result__suggestion">
        {didYouMean.length > 0 && <p id="didyoumean">Menade du: </p>}
        <ul aria-labelledby="didyoumean">
          {didYouMean.map((sugge, i) => (
            <li key={i}>
              <a href={`${this.props.searchPageLink}?q=${sugge['Suggestion']}`}>{sugge['Suggestion']}</a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  //Render item
  private renderItem = (item: ResultItem, index: number): JSX.Element => {
    const breadCrumbs = item['SearchResultsBreadCrumbs'] || [];
    let itemClass =
      item.ItemType == 'Dokument' && item.ShoppingAdressUrl != null
        ? 'search-result__item search-result__sharepointItem'
        : 'search-result__item';

    return (
      <div key={index} className={itemClass}>
        <h3>
          <a className={item.Type + item.SharePointFileExtensionClass} href={item['Url']}>
            {item['Title']}
          </a>
        </h3>
        {!item.BestBetsExternalLink && (
          <div className={`search-result__date text-micro ${item.DateClassModifier}`}>
            {' '}
            Senast uppdaterad {item['StartDate']}{' '}
          </div>
        )}
        {item.Type === null && item['MainText'] != '' && item.ItemType != 'Dokument' && (
          <div className="search-result__text">{item['MainText']}</div>
        )}

        {item.ItemType != 'Dokument' && (
          <ol className="search-result__breadcrumbs" aria-label="Hierarkisk position på webbplatsen för denna sökträff">
            <li key="startpage">
              <a className="text-micro" href={item.StartPageExternalUrl}>
                {' '}
                {item.StartPageName}
              </a>
            </li>

            {breadCrumbs.map((breadcrumb, i) => (
              <li key={i}>
                <a className="text-micro" href={breadcrumb.Url}>
                  {breadcrumb.Name}
                </a>
              </li>
            ))}

            {item.StartPageName != null && (
              <li>
                <a className="text-micro" href={item['Url']}>
                  {item['Title']}
                </a>
              </li>
            )}
          </ol>
        )}

        {item.ItemType == 'Dokument' && item.ShoppingAdressUrl != null && item.CanShop && (
          <a className="fileinformation__item-shop" href={item.ShoppingAdressUrl}>
            <div className="fileinformation__item-shop-icon" />
            Beställ
          </a>
        )}
      </div>
    );
  };

  toggleIsDocumentOnly = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isDocOnly = e.currentTarget.checked;
    let searchStateClone = _.cloneDeep(this.state.currentSearchState);
    searchStateClone.IsDocument = isDocOnly;

    this.setState({
      currentSearchState: searchStateClone,
    });
  };

  //Render the whole checkbox list
  private renderCheckbox = (): JSX.Element => {
    const { categoryFilter, searchCategories, useFacets } = this.props;
    const isFileOnlyChecked = this.state.currentSearchState.IsDocument;
    const fileOnlyClass = isFileOnlyChecked ? 'page-list__label-checked' : '';
    return (
      <div className="page-list">
        <div className="search-result__filters page-list__filters filters">
          <div className="search-result__filter-categories">
            <fieldset>
              {categoryFilter.length > 0 && <legend className="filters__filter-text">Verksamhetsområden</legend>}
              <div className="search-result__filter-item">
                {categoryFilter
                  .filter((c) => c.Category === CategoryType.Mandatory)
                  .map((category, i) => {
                    return (
                      <ToggleBox
                        key={`operationsbox-${i}`}
                        label={category.Name}
                        value={category.Id.toString()}
                        cssClass="togglebox--white"
                        onChangeCb={this.checkItem}
                      />
                    );
                  })}

                <div className="search-result__filter-types">
                  <div className="search-result__filter-item types">
                    <label>
                      <input type="checkbox" className={fileOnlyClass} onChange={this.toggleIsDocumentOnly} /> Visa
                      endast filer{' '}
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        {useFacets
          ? searchCategories.length > 0 && (
              <div className="search-result__filter-categories">
                <details>
                  <summary>Filtrera sökning</summary>
                  <fieldset>
                    <legend className="sr-only">Kategorier</legend>
                    <div className="page-list__filters">
                      {searchCategories.map((category, i) => {
                        return (
                          <ToggleBox
                            key={`searchfilterbox-${i}`}
                            label={category.Term}
                            value={category.Term}
                            cssClass="togglebox--white"
                            onChangeCb={this.checkItem}
                          />
                        );
                      })}
                    </div>
                  </fieldset>
                </details>
              </div>
            )
          : categoryFilter.filter((c) => c.Category === CategoryType.Product).length > 0 && (
              <div className="search-result__filter-categories">
                <details>
                  <summary>Filtrera sökning</summary>
                  <fieldset>
                    <legend className="sr-only">Kategorier</legend>
                    <div className="page-list__filters">
                      {categoryFilter
                        .filter((c) => c.Category === CategoryType.Product)
                        .map((category, i) => {
                          return (
                            <ToggleBox
                              key={`searchfilterbox-${i}`}
                              label={category.Name}
                              value={category.Id.toString()}
                              cssClass="togglebox--white"
                              onChangeCb={this.checkItem}
                            />
                          );
                        })}
                    </div>
                  </fieldset>
                </details>
              </div>
            )}
      </div>
    );
  };
}
